import { Link } from 'react-router-dom';
import s from './HeaderMenuListView.module.css';
import oficcePro from '../../images/header/Group 3590.jpeg';

const MenuList = ({ menu }) => {
  return (
    <>
      <div className={s.menu}>
        <ul className={s.menuList}>
          {menu.map(({ id, title, path }) => (
            <li className={s.menuItem} key={id}>
              {' '}
              <Link to={`/${path}`} className={s.menuLink}>
                {title}
              </Link>
            </li>
          ))}
        </ul>
        <Link to="/" className={s.listThumbImg}>
          <img src={oficcePro} alt={oficcePro} className={s.listImg} />
        </Link>
      </div>
    </>
  );
};

export default MenuList;
